import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-custom mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "p-field mb-4"
}
const _hoisted_3 = { class: "fw-bold mb-2" }
const _hoisted_4 = { class: "p-field my-1" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "p-field-label my-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-field mt-3" }
const _hoisted_9 = { class: "p-field-label" }
const _hoisted_10 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_11 = { class: "p-field mt-3" }
const _hoisted_12 = { class: "p-field-label" }
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-start mt-3"
}
const _hoisted_15 = { class: "pl-2 warning-label" }
const _hoisted_16 = { class: "p-field my-4" }
const _hoisted_17 = { class: "p-field-label my-2" }
const _hoisted_18 = { class: "p-field my-4" }
const _hoisted_19 = { class: "p-field-label my-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "d-flex align-items-center mt-3" }
const _hoisted_22 = { class: "p-field-label" }
const _hoisted_23 = { class: "bt-icon bt-icon--xs" }
const _hoisted_24 = { class: "ml-2" }
const _hoisted_25 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_HourPicker = _resolveComponent("HourPicker")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_TimesSlot = _resolveComponent("TimesSlot")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ElScrollbar, { class: "details-panel-content" }, {
      default: _withCtx(() => [
        (_ctx.gates.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("AppResourceEP.SelectTheGatesWhereEnableTheAccess")), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gates, (g, gateIdx) => {
                return (_openBlock(), _createBlock(_component_ListItemCheck, {
                  key: g.gateId,
                  disabled: _ctx.disabled,
                  label: g.name,
                  value: g.gateId,
                  modelValue: _ctx.editingGuest.gateIds,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingGuest.gateIds = $event)),
                    _ctx.guestWasEdited
                  ],
                  name: "specificGate",
                  inputId: 'specificg' + gateIdx,
                  last: gateIdx == _ctx.gates.length - 1
                }, null, 8, ["disabled", "label", "value", "modelValue", "inputId", "last", "onUpdate:modelValue"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_4, [
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResourceEP.Permissions")), 1),
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.DateUpper")), 1),
          (_ctx.editingGuest.isRecurrent)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("div", {
                  class: ["menu-filters", {'p-disabled': _ctx.disabled}]
                }, [
                  _createVNode(_component_SelectButton, {
                    disabled: _ctx.disabled,
                    modelValue: _ctx.editingGuest.isDateAlways,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editingGuest.isDateAlways = $event)),
                    options: _ctx.dateSettingsList,
                    dataKey: "value",
                    optionLabel: "label",
                    optionValue: "value"
                  }, null, 8, ["disabled", "modelValue", "options"])
                ], 2),
                (!_ctx.editingGuest.isDateAlways)
                  ? (_openBlock(), _createBlock("span", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.From")), 1),
                        _createVNode("div", _hoisted_10, [
                          _createVNode(_component_Calendar, {
                            disabled: _ctx.disabled,
                            modelValue: _ctx.dateSince,
                            "onUpdate:modelValue": [
                              _cache[3] || (_cache[3] = ($event: any) => (_ctx.dateSince = $event)),
                              _ctx.dateSinceUpdate
                            ],
                            class: "w-50",
                            dateFormat: "dd MM yy",
                            showIcon: "",
                            manualInput: false,
                            "min-date": _ctx.minDate,
                            "max-date": _ctx.maxDate
                          }, null, 8, ["disabled", "modelValue", "min-date", "max-date", "onUpdate:modelValue"]),
                          _createVNode(_component_HourPicker, {
                            modelValue: _ctx.dateSinceHour,
                            "onUpdate:modelValue": [
                              _cache[4] || (_cache[4] = ($event: any) => (_ctx.dateSinceHour = $event)),
                              _ctx.dateSinceHourUpdate
                            ],
                            width: "w-25",
                            disabled: _ctx.disabled || _ctx.validityHoursDisabled
                          }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_11, [
                        _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResource.To")), 1),
                        _createVNode("div", _hoisted_13, [
                          _createVNode(_component_Calendar, {
                            disabled: _ctx.disabled,
                            modelValue: _ctx.dateUntil,
                            "onUpdate:modelValue": [
                              _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateUntil = $event)),
                              _ctx.dateUntilUpdate
                            ],
                            class: "w-50",
                            dateFormat: "dd MM yy",
                            showIcon: "",
                            manualInput: false,
                            "min-date": _ctx.minDurationUntilDate,
                            "max-date": _ctx.maxDate,
                            inputClass: {
                                        'input-error': _ctx.dateNotValid,
                                    }
                          }, null, 8, ["disabled", "modelValue", "min-date", "max-date", "inputClass", "onUpdate:modelValue"]),
                          _createVNode(_component_HourPicker, {
                            modelValue: _ctx.dateUntilHour,
                            "onUpdate:modelValue": [
                              _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateUntilHour = $event)),
                              _ctx.dateUntilHourUpdate
                            ],
                            width: "w-25",
                            disabled: _ctx.disabled || _ctx.validityHoursDisabled
                          }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
                        ])
                      ]),
                      (_ctx.validityHoursDisabled)
                        ? (_openBlock(), _createBlock("div", _hoisted_14, [
                            _createVNode(_component_InlineSvgScoped, {
                              class: "svg-icon-alert",
                              src: require(`@/assets/images/icons/icon-alert-medium-outline.svg`),
                              "aria-label": "icon-alert"
                            }, null, 8, ["src"]),
                            _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("AppResourceEP.TimeValidityFWNotSupportedWarning")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_16, [
                  _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("AppResourceEP.Repetition")), 1),
                  _createVNode("div", {
                    class: ["menu-filters menu-filters--rounded", {'p-disabled': _ctx.disabled}]
                  }, [
                    _createVNode(_component_SelectButton, {
                      disabled: _ctx.disabled,
                      multiple: "",
                      modelValue: _ctx.editingGuest.repetitionDays,
                      "onUpdate:modelValue": [
                        _cache[7] || (_cache[7] = ($event: any) => (_ctx.editingGuest.repetitionDays = $event)),
                        _ctx.guestWasEdited
                      ],
                      options: _ctx.weekDaySettingList,
                      dataKey: "value",
                      optionLabel: "label",
                      optionValue: "value"
                    }, null, 8, ["disabled", "modelValue", "options", "onUpdate:modelValue"])
                  ], 2)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.editingGuest.isOneTimeGuest)
            ? (_openBlock(), _createBlock(_component_Calendar, {
                key: 1,
                disabled: _ctx.disabled,
                modelValue: _ctx.dateUntil,
                "onUpdate:modelValue": [
                  _cache[8] || (_cache[8] = ($event: any) => (_ctx.dateUntil = $event)),
                  _ctx.dateUntilUpdate
                ],
                class: ["w-50", { 'w-100': !_ctx.isEdit }],
                dateFormat: "dd MM yy",
                showIcon: "",
                manualInput: false,
                minDate: _ctx.minDate
              }, null, 8, ["disabled", "modelValue", "minDate", "class", "onUpdate:modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AppResource.TimeUpper")), 1),
          _createVNode("div", {
            class: ["menu-filters", {'p-disabled': _ctx.disabled}]
          }, [
            _createVNode(_component_SelectButton, {
              disabled: _ctx.disabled,
              modelValue: _ctx.editingGuest.isTimeAlways,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.editingGuest.isTimeAlways = $event)),
              options: _ctx.timeSettingsList,
              dataKey: "value",
              optionLabel: "label",
              optionValue: "value"
            }, null, 8, ["disabled", "modelValue", "options"])
          ], 2),
          (!_ctx.editingGuest.isTimeAlways)
            ? (_openBlock(), _createBlock("span", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("entrancePlant.permissionsTimeRanges")), 1),
                  _createVNode(_component_Button, {
                    class: "p-button-rounded p-button-outlined ml-auto mr-3",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addTimeSlot())),
                    disabled: _ctx.timesSlotsWithValidation.length >= 2||_ctx.disabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_23, [
                        _createVNode(_component_InlineSvgScoped, {
                          src: 
                                        require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                          "aria-label": "icon-grid"
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timesSlotsWithValidation, (slot, slotIndex) => {
                  return (_openBlock(), _createBlock(_Fragment, { key: slotIndex }, [
                    _createVNode(_component_TimesSlot, {
                      disabled: _ctx.disabled,
                      isEdit: _ctx.isEdit,
                      tSlot: slot,
                      timesSlotslength: _ctx.timesSlotsWithValidation.length,
                      onDeleteSlot: _ctx.handleTimeSlotRemove,
                      onTimeSlotEdited: _ctx.guestWasEdited
                    }, null, 8, ["disabled", "isEdit", "tSlot", "timesSlotslength", "onDeleteSlot", "onTimeSlotEdited"]),
                    _hoisted_25
                  ], 64))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}